"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReverseOrderedTreasuryYieldSeriesIdAndYears = exports.AllTreasuryYieldSeriesIds = exports.StLouisFedSeriesId = exports.StLouisFedRequestType = void 0;
var StLouisFedRequestType;
(function (StLouisFedRequestType) {
    StLouisFedRequestType["fredSeriesObservations"] = "/fred/series/observations";
})(StLouisFedRequestType || (exports.StLouisFedRequestType = StLouisFedRequestType = {}));
// Reference: https://fred.stlouisfed.org/graph/?id=DGS1,DGS2,DGS3,DGS5,DGS10,DGS20,DGS30
// Reference: https://fred.stlouisfed.org/series/DFEDTARU
/**  @TranslateToPython @TranslateToEnum  */
var StLouisFedSeriesId;
(function (StLouisFedSeriesId) {
    /** Market Yield on U.S. Treasury Securities at 1-Year Constant Maturity (https://fred.stlouisfed.org/series/DGS1) */
    StLouisFedSeriesId["DGS1"] = "DGS1";
    /** Market Yield on U.S. Treasury Securities at 2-Year Constant Maturity (https://fred.stlouisfed.org/series/DGS2) */
    StLouisFedSeriesId["DGS2"] = "DGS2";
    /** Market Yield on U.S. Treasury Securities at 3-Year Constant Maturity (https://fred.stlouisfed.org/series/DGS3) */
    StLouisFedSeriesId["DGS3"] = "DGS3";
    /** Market Yield on U.S. Treasury Securities at 5-Year Constant Maturity (https://fred.stlouisfed.org/series/DGS5) */
    StLouisFedSeriesId["DGS5"] = "DGS5";
    /** Market Yield on U.S. Treasury Securities at 10-Year Constant Maturity (https://fred.stlouisfed.org/series/DGS10) */
    StLouisFedSeriesId["DGS10"] = "DGS10";
    /** Market Yield on U.S. Treasury Securities at 20-Year Constant Maturity (https://fred.stlouisfed.org/series/DGS20) */
    StLouisFedSeriesId["DGS20"] = "DGS20";
    /** Market Yield on U.S. Treasury Securities at 30-Year Constant Maturity (https://fred.stlouisfed.org/series/DGS30) */
    StLouisFedSeriesId["DGS30"] = "DGS30";
    /** Federal Funds Target Rate - Upper Limit (https://fred.stlouisfed.org/series/DFEDTARU) */
    StLouisFedSeriesId["DFEDTARU"] = "DFEDTARU";
    /** Bank Prime Loan Rate, same as WSJ Prime Rate (https://fred.stlouisfed.org/series/DPRIME) */
    StLouisFedSeriesId["DPRIME"] = "DPRIME";
})(StLouisFedSeriesId || (exports.StLouisFedSeriesId = StLouisFedSeriesId = {}));
exports.AllTreasuryYieldSeriesIds = [
    StLouisFedSeriesId.DGS1,
    StLouisFedSeriesId.DGS2,
    StLouisFedSeriesId.DGS3,
    StLouisFedSeriesId.DGS5,
    StLouisFedSeriesId.DGS10,
    StLouisFedSeriesId.DGS20,
    StLouisFedSeriesId.DGS30,
];
exports.ReverseOrderedTreasuryYieldSeriesIdAndYears = [
    [StLouisFedSeriesId.DGS30, 30],
    [StLouisFedSeriesId.DGS20, 20],
    [StLouisFedSeriesId.DGS10, 10],
    [StLouisFedSeriesId.DGS5, 5],
    [StLouisFedSeriesId.DGS3, 3],
    [StLouisFedSeriesId.DGS2, 2],
    [StLouisFedSeriesId.DGS1, 1],
];
